import React from 'react';

import "./styles.css";

export default function MapProjectUnclaimedView(props) {

  if (props) {

    if (props.project) {

    return (
      <div className={`project project--view project--inline`}>
        <div className="project__content">
          <div className="project__content-head">
            <div className="project__content-head-inner">
              <h4 className="project__title">
                Unclaimed Project
              </h4>
              <span className="project__location">
                This is a known mass timber project that is ready to be claimed on WIN.
                If you're part of the <strong>design or construction team</strong>, claim this project by <a className="win-link" href="/registration/">requesting a WIN account</a>.
              </span>
            </div>
          </div>
        </div>
        <div className="project__close">
          <a href="/projects" onClick={event => {
            event.preventDefault();
            let el = document.getElementById('marker-item-' + props.project.id);
            if (el) {
              let img = el.dataset.img;
              el.src = img;
            }
            props.project.handleProjectViewClose(null);
          }}>
          <i className="ico-close">
            <svg>
              <use xlinkHref="#ico-close"></use>
            </svg>
          </i>
          </a>
        </div>
      </div>
    );
  }
}
return null
}
